export type DeviceKind = "mobile" | "desktop";

const MOBILE_UA = /Mobi|Android|iPhone|iPad|iPod|IEMobile|Opera Mini|webOS|BlackBerry/i;

/**
 * Whether this browser runs on a phone / tablet ("mobile") or a computer ("desktop"). It is
 * the kind of device, not the window width: game lists only show games built for it
 * (isMobile / isDesktop) and games open in the matching build.
 */
export const getDeviceKind = (): DeviceKind => {
  if (typeof navigator === "undefined") return "desktop";
  const uaData = (navigator as Navigator & { userAgentData?: { mobile?: boolean } }).userAgentData;
  if (uaData?.mobile) return "mobile";
  if (MOBILE_UA.test(navigator.userAgent)) return "mobile";
  // iPadOS reports itself as a Mac; a touch screen gives it away
  if (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1) return "mobile";
  return "desktop";
};
